import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import "./Quiz.css";

import {
    getQuiz,
    startQuiz
} from "../../services/quizApi";

function QuizDetails() {

    const navigate = useNavigate();

    const location = useLocation();

    const {

        standard,

        subject

    } = location.state || {};

    const [studentName, setStudentName] = useState("");

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const handleStartQuiz = async () => {

        if (!studentName.trim()) {

            setError("Please enter your name.");

            return;

        }

        try {

            setLoading(true);

            setError("");

            const quiz = await getQuiz(

                standard,

                subject

            );

            if (!quiz || !quiz._id) {

                setError("No quiz available for this subject.");

                return;

            }

            const startResponse = await startQuiz({

                quizId: quiz._id,

                studentName,

                standard,

                subject

            });

            navigate("/quiz-play", {
                state: {
                    quiz,
                    studentName,
                    submissionId: startResponse.submissionId,
                    startedAt: startResponse.startedAt
                }
            });

        }

        catch (error) {

            setError(

                error.response?.data?.message ||

                "Unable to start quiz."

            );

        }

        finally {

            setLoading(false);

        }

    };
    return (

        <div className="quiz-details-page">

            <div className="quiz-details-card">

                <h2>

                    Quiz Details

                </h2>

                <div className="quiz-info">

                    <div className="info-group">

                        <label>

                            Standard

                        </label>

                        <input

                            type="text"

                            value={standard}

                            readOnly

                        />

                    </div>

                    <div className="info-group">

                        <label>

                            Subject

                        </label>

                        <input

                            type="text"

                            value={subject}

                            readOnly

                        />

                    </div>

                    <div className="info-group">

                        <label>

                            Student Name

                        </label>

                        <input

                            type="text"

                            placeholder="Enter your full name"

                            value={studentName}

                            onChange={(e) =>

                                setStudentName(e.target.value)

                            }

                        />

                    </div>

                </div>

                {

                    error && (

                        <p className="quiz-error">

                            {error}

                        </p>

                    )

                }

                <button

                    className="start-quiz-btn"

                    onClick={handleStartQuiz}

                    disabled={loading}

                >

                    {

                        loading

                            ? "Starting Quiz..."

                            : "Start Quiz"

                    }

                </button>

            </div>

        </div>

    );

}

export default QuizDetails;